var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDfLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#CD1E26"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7667 25.6531C15.9206 27.0008 16.6483 28.0856 17.4289 29.1314C17.2625 29.2559 17.1832 29.161 17.107 29.1096C14.9737 27.6981 13.0673 26.0453 11.6259 23.9038C9.78956 21.1725 9.95749 18.4552 12.0753 15.9216C13.128 14.6641 14.4372 13.6711 15.5303 12.4572C16.6778 11.1826 17.4662 9.78351 17.2952 7.98443C17.2252 7.2592 16.9577 6.60244 16.6265 5.80717C19.8841 8.09493 22.7622 10.5056 24.1275 14.2781C25.0449 16.8149 24.7463 19.1524 23.1308 21.3172C22.3735 22.3319 21.5852 23.3124 20.3008 24.1621C21.3613 22.514 21.5401 20.9188 21.3535 19.2349C21.1513 17.4063 20.8279 17.2148 19.3134 18.186C17.2578 19.5042 16.0495 21.2238 15.7542 23.8042C15.6721 24.5222 15.7682 25.6546 15.7682 25.6546L15.7667 25.6531Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDfLogo);
export default __webpack_public_path__ + "static/media/df_logo.9396067d2f396372bd01dc10d28b5473.svg";
export { ForwardRef as ReactComponent };